import axios from 'axios';
import { handleErrors } from '../../utils/api';
import { API_CONFIG } from '../../constants/config';

export const GET_INDUSTRIES_PENDING = 'GET_INDUSTRIES_PENDING';
export const GET_INDUSTRIES_FAIL = 'GET_INDUSTRIES_FAIL';
export const GET_INDUSTRIES_SUCCESS = 'GET_INDUSTRIES_SUCCESS';

export const getIndustries = (params = { search: null }) => async (dispatch) => {
  dispatch({
    type: GET_INDUSTRIES_PENDING,
    payload: {},
  });
  try {
    const response = await axios.get(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/industries/`,
      { params, withCredentials: true },
    );
    dispatch({
      type: GET_INDUSTRIES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};
